// core.js
import { apiProvider } from './Provider';

export class ApiCore {
    constructor(options) {
        if (options.get) {
            this.get = async () => {
                return await apiProvider.get(options.url);
            };
        }

        if (options.getSingle) {
            this.getSingle = async (id) => {
                return await apiProvider.getSingle(options.url, id);
            };
        }

        if (options.search) {
            this.search = async (search) => {
                return await apiProvider.search(options.url, search);
            };
        }

        if (options.post) {
            this.post = async (model) => {
                return await apiProvider.post(options.url, model);
            };
        }

        if (options.put) {
            this.put = async (model) => {
                return await apiProvider.put(options.url, model);
            };
        }

        if (options.remove) {
            this.remove = async (id) => {
                return await apiProvider.remove(options.url, id);
            };
        }
    }
}

export default ApiCore;
